import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * Command to reorder an existing issue status entity by updating its sorting value.
 */
export class ReorderIssueStatusCommand extends AbstractCommand<IssueStatus> {

    public name = CommandName.REORDER_ISSUE_STATUS;

    public tags: string[] = [`entity`, `update`, `issue-status`];

    constructor(payload: IssueStatus) {
        super('issue-status', payload.uid, payload);
    }
}
